module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-180x180-316becf8751891e9477973a10467c046.png";